<template>
  <div class="animated fadeIn frm-appaymplan">
    <b-card>
      <div slot="header">AP Payment Plan
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <span v-if="(showFilter==1)">Hide </span><span v-else>Show </span> Header 
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="(showFilter==1)">
        <b-col md="7" lg="6">
            <b-input-group >
              <b-input-group-prepend><label>Created Date</label></b-input-group-prepend>
              <b-form-input v-model="model.createdate" type="date" disabled ></b-form-input>
              <b-input-group-prepend ><span class="input-group-text">by</span></b-input-group-prepend>
              <b-form-input v-model="model.createby" disabled></b-form-input>
            </b-input-group>
              <b-input-group>
                  <b-input-group-prepend ><label>Payment Period </label></b-input-group-prepend>
                  <b-form-input v-model="model.paym_sched" type="date" disabled></b-form-input>
                  <b-input-group-prepend ><span class="input-group-text">-</span></b-input-group-prepend>
                  <b-form-input v-model="model.expir_sched"  type="date" disabled></b-form-input>
              </b-input-group>
        </b-col>
        <b-col md="4" lg="3">
              <b-input-group v-for="(row) in aging.valas" :key="row.tukarkey">
                  <b-input-group-prepend ><label>Rate {{row.valasfr}} </label></b-input-group-prepend>
                  <b-form-input v-model="row.kurs" type="number" ></b-form-input>
                  <b-input-group-prepend ><span class="input-group-text">{{row.valasto}}</span></b-input-group-prepend>
              </b-input-group>
        </b-col>
        <b-col md="3" lg="2">
            <b-button class="ml-3 btn btn-warning" @click="processValas()" > <i class="fa fa-calculator"></i> RE-CALC AP FOREX</b-button>                
        </b-col>

      </b-row>

      <b-card no-body >
        <b-tabs card v-model="model.tabIndex">
          <b-tab title="Summary by Vendor & Currency">
            <b-row v-if="(filterShow=='Hide')">
                <b-col lg="6">
                    <b-form-group
                        label="Filter"
                        label-cols-sm="1"
                        label-size="sm"
                        label-for="filterInput"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>            
                </b-col>         
                <b-col lg="6">
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                </b-col>         
            </b-row>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="aging.rekap"
                :fields="tblLcy.fields"
                :current-page="tblLcy.page"
                :per-page="tblLcy.limit"
                :sort-by.sync="tblLcy.sortBy"
                :sort-desc.sync="tblLcy.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
                <template v-slot:head(totalLcy)="data">
                  <span >Total Outstand in {{uanguser}} (Local Currency)</span>
                </template>
                <template v-slot:cell(totalLcy)="data">
                    {{ data.item.totalLcy | numFormat }}
                </template>
                <template v-slot:head(aging1Lcy)="data">
                  <span v-if="(aging.seting.apAge1)" class="text-info">{{aging.seting.apAge1}} Days</span>
                  <span v-else class="text-info">30 Days</span>
                </template>
                <template v-slot:cell(aging1Lcy)="data">
                  <a href="javascript:void(0)" @click.stop="getRekap(data.item,1)">
                      {{ data.item.aging1Lcy | numFormat }}
                  </a>                    
                </template>
                <template v-slot:head(aging2Lcy)="data">
                  <span v-if="(aging.seting.apAge2)" class="text-info">{{aging.seting.apAge2}} Days</span>
                  <span v-else class="text-info">60 Days</span>
                </template>
                <template v-slot:cell(aging2Lcy)="data">
                  <a href="javascript:void(0)" @click.stop="getRekap(data.item,2)">
                      <span v-if="(data.item.aging2Byr)" style="background-color:#B4F8C8;">{{(data.item.aging2Lcy)|numFormat}}</span><span v-else>{{(data.item.aging2Lcy)|numFormat}}</span>
                  </a>                    
                </template>
                <template v-slot:head(aging3Lcy)="data">
                  <span v-if="(aging.seting.apAge3)" class="text-info">{{aging.seting.apAge3}} Days</span>
                  <span v-else class="text-info">90 Days</span>
                </template>
                <template v-slot:cell(aging3Lcy)="data">
                  <a href="javascript:void(0)" @click.stop="getRekap(data.item,3)">
                      <span v-if="(data.item.aging3Byr)" style="background-color:#B4F8C8;">{{(data.item.aging3Lcy)|numFormat}}</span><span v-else>{{(data.item.aging3Lcy)|numFormat}}</span>
                  </a>                    
                </template>
                <template v-slot:head(aging4Lcy)="data">
                  <span v-if="(aging.seting.apAge4)" class="text-info">{{aging.seting.apAge4}} Days</span>
                  <span v-else class="text-info">180 Days</span>
                </template>
                <template v-slot:cell(aging4Lcy)="data">
                  <a href="javascript:void(0)" @click.stop="getRekap(data.item,4)">
                      <span v-if="(data.item.aging4Byr)" style="background-color:#B4F8C8;">{{(data.item.aging4Lcy)|numFormat}}</span><span v-else>{{(data.item.aging4Lcy)|numFormat}}</span>
                  </a>                    
                </template>
                <template v-slot:head(aging5Lcy)="data">
                  <span v-if="(aging.seting.apAge5)" class="text-info"> > {{aging.seting.apAge5}} Days</span>
                  <span v-else class="text-info"> > 180 Days</span>
                </template>
                <template v-slot:cell(aging5Lcy)="data">
                  <a href="javascript:void(0)" @click.stop="getRekap(data.item,5)">
                      <span v-if="(data.item.aging5Byr)" style="background-color:#B4F8C8;">{{(data.item.aging5Lcy)|numFormat}}</span><span v-else>{{(data.item.aging5Lcy)|numFormat}}</span>
                  </a>                    
                </template>
              <template v-slot:cell(latestPaym)="data">
                <span v-if="(data.item.latestPaym)">
                {{ data.item.latestPaym | moment("DDMMMYYYY") }}
                </span>
              </template>
                <template v-slot:head(totalByr)="data">Payment Plan ({{model.matauang}})</template>
                <template v-slot:cell(totalByr)="data">{{(data.item.totalByr)|numFormat}}</template>
            </b-table>
            <b-row class="mt-2">
                <b-col cols="4">
                    <div style="font-weight: bolder;">Total Outstanding : {{uanguser}} {{aging.totalLcy | numFormat}}</div>
                </b-col>
                <b-col cols="8">
                    <b-row >
                      <b-col cols="6" style="text-align:center">
                        <div>
                          Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                          to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                          of {{tblLcy.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                          <select  v-model="tblLcy.limit"  style="width:60px;">
                            <option>10</option>
                            <option>20</option>
                            <option>30</option>                            
                            <option>40</option>
                            <option>50</option>                            
                            <option>60</option>                            
                            <option>70</option>                            
                            <option>80</option>                            
                            <option>90</option>                            
                            <option>100</option>                            
                          </select>
                        </div>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="6">            
                        <b-pagination 
                          align="right"
                          :total-rows="tblLcy.total"
                          :per-page="tblLcy.limit"
                          v-model="tblLcy.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </b-tab>
          <!-- <b-tab title="Exchange Rate">
            <b-row>
              <b-col md="10" lg="9">
                <table style="width: 100%;">
                  <thead>
                    <tr>
                      <th width="120px">Date</th>
                      <th >From Currency </th>
                      <th width="70px" style="text-align:center">Into</th>
                      <th style="text-align:center">Rate</th>
                      <th >Description </th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(row) in aging.valas" :key="row.tukarkey" >
                          <td>{{row.tanggal | moment("DD MMM YYYY")}}</td>
                          <td>{{row.matauang}}</td>
                          <td>{{aging.seting.matauang}}</td>
                          <td style="text-align:right">            
                            <b-form-input v-model="row.kurs" type="number" ></b-form-input>
                          </td>
                          <td>{{row.uraian}}</td>
                      </tr>
                  </tbody>
                </table>
              </b-col>
              <b-col md="3" lg="2">
                  <b-button class="ml-3 btn btn-warning" @click="processValas()" > <i class="fa fa-calculator"></i> RE-PROCESS FOREIGN CURRENCY</b-button>                
              </b-col>
            </b-row>
          </b-tab> -->
          <b-tab title="Summary by Vendor" active>
            <b-row v-if="(filterVndShow=='Hide')">
                <b-col lg="6">
                    <b-form-group
                        label="Filter"
                        label-cols-sm="1"
                        label-size="sm"
                        label-for="filterVnd"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            v-model="filterVnd"
                            type="search"
                            id="filterVnd"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button :disabled="!filterVnd" @click="filterVnd = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>            
                </b-col>         
                <b-col lg="6">
                        <b-form-checkbox v-model="filterVndShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterVndShow }}</b> Filter
                        </b-form-checkbox>
                </b-col>         
            </b-row>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="aging.rekapVendor"
                :fields="tblRekap.fields"
                :current-page="tblRekap.page"
                :per-page="tblRekap.limit"
                :sort-by.sync="tblRekap.sortBy"
                :sort-desc.sync="tblRekap.sortDesc"
                :filter="filterVnd"
                :filterIncludedFields="filterVndOn"
                @filtered="onFilterVendor"                
            >
                <template v-slot:head(totalLcy)="data">
                  <span >Total Outstand in {{uanguser}} (Local Currency)</span>
                </template>
                <template v-slot:cell(totalLcy)="data">
                    {{ data.item.totalLcy | numFormat }}
                </template>
                <template v-slot:head(aging1Lcy)="data">
                  <span v-if="(aging.seting.apAge1)" class="text-info">{{aging.seting.apAge1}} Days</span>
                  <span v-else class="text-info">30 Days</span>
                </template>
                <template v-slot:cell(aging1Lcy)="data">
                  <a href="javascript:void(0)" @click.stop="getDetail(data.item,1)">
                      <span v-if="(data.item.aging1Byr)" style="background-color:#B4F8C8;">{{(data.item.aging1Lcy)|numFormat}}</span><span v-else>{{(data.item.aging1Lcy)|numFormat}}</span>
                  </a>                    
                </template>
                <template v-slot:head(aging2Lcy)="data">
                  <span v-if="(aging.seting.apAge2)" class="text-info">{{aging.seting.apAge2}} Days</span>
                  <span v-else class="text-info">60 Days</span>
                </template>
                <template v-slot:cell(aging2Lcy)="data">
                  <a href="javascript:void(0)" @click.stop="getDetail(data.item,2)">
                      <span v-if="(data.item.aging2Byr)" style="background-color:#B4F8C8;">{{(data.item.aging2Lcy)|numFormat}}</span><span v-else>{{(data.item.aging2Lcy)|numFormat}}</span>
                  </a>                    
                </template>
                <template v-slot:head(aging3Lcy)="data">
                  <span v-if="(aging.seting.apAge3)" class="text-info">{{aging.seting.apAge3}} Days</span>
                  <span v-else class="text-info">90 Days</span>
                </template>
                <template v-slot:cell(aging3Lcy)="data">
                  <a href="javascript:void(0)" @click.stop="getDetail(data.item,3)">
                      <span v-if="(data.item.aging3Byr)" style="background-color:#B4F8C8;">{{(data.item.aging3Lcy)|numFormat}}</span><span v-else>{{(data.item.aging3Lcy)|numFormat}}</span>
                  </a>                    
                </template>
                <template v-slot:head(aging4Lcy)="data">
                  <span v-if="(aging.seting.apAge4)" class="text-info">{{aging.seting.apAge4}} Days</span>
                  <span v-else class="text-info">180 Days</span>
                </template>
                <template v-slot:cell(aging4Lcy)="data">
                  <a href="javascript:void(0)" @click.stop="getDetail(data.item,4)">
                      <span v-if="(data.item.aging4Byr)" style="background-color:#B4F8C8;">{{(data.item.aging4Lcy)|numFormat}}</span><span v-else>{{(data.item.aging4Lcy)|numFormat}}</span>
                  </a>                    
                </template>
                <template v-slot:head(aging5Lcy)="data">
                  <span v-if="(aging.seting.apAge5)" class="text-info"> > {{aging.seting.apAge5}} Days</span>
                  <span v-else class="text-info"> > 180 Days</span>
                </template>
                <template v-slot:cell(aging5Lcy)="data">
                  <a href="javascript:void(0)" @click.stop="getDetail(data.item,5)">
                      <span v-if="(data.item.aging5Byr)" style="background-color:#B4F8C8;">{{(data.item.aging5Lcy)|numFormat}}</span><span v-else>{{(data.item.aging5Lcy)|numFormat}}</span>
                  </a>                    
                </template>
              <template v-slot:cell(latestPaym)="data">
                <span v-if="(data.item.latestPaym)">
                {{ data.item.latestPaym | moment("DDMMMYYYY") }}
                </span>
              </template>
                <template v-slot:head(totalByr)="data">Payment Plan ({{model.matauang}})</template>
                <template v-slot:cell(totalByr)="data">{{(data.item.totalByr)|numFormat}}</template>
            </b-table>
            <b-row class="mt-2">
                <b-col cols="4">
                    <div style="font-weight: bolder;">Total Outstanding : {{uanguser}} {{aging.totalLcy | numFormat}}</div>
                </b-col>
                <b-col cols="8">
                    <b-row >
                      <b-col cols="6" style="text-align:center">
                        <div>
                          Showing {{(tblRekap.page - 1) * tblRekap.limit + 1}}
                          to <span v-if="((tblRekap.page * tblRekap.limit)>tblRekap.total)">{{tblRekap.total}}</span> <span v-else>{{tblRekap.page * tblRekap.limit}}</span>
                          of {{tblRekap.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                          <select  v-model="tblRekap.limit"  style="width:60px;">
                            <option>10</option>
                            <option>20</option>
                            <option>30</option>                            
                            <option>40</option>
                            <option>50</option>                            
                            <option>60</option>                            
                            <option>70</option>                            
                            <option>80</option>                            
                            <option>90</option>                            
                            <option>100</option>                            
                          </select>
                        </div>
                        <b-form-checkbox v-model="filterVndShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterVndShow }}</b> Filter
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="6">            
                        <b-pagination 
                          align="right"
                          :total-rows="tblRekap.total"
                          :per-page="tblRekap.limit"
                          v-model="tblRekap.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </b-tab>

          <b-tab title="Detail AP Outstanding" >
            <b-row v-if="(filterDtlShow=='Hide')">
                <b-col lg="4">
                  <b-input-group size="sm">
                      <b-form-checkbox v-model="filterDtlShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                      <b-input-group-prepend> <span class="pr-2">
                          <b> {{ filterDtlShow }}</b>  Filter </span>
                      </b-input-group-prepend>
                      <b-form-input v-model="filterDtl" type="search" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                          <b-button :disabled="!filterDtl" @click="filterDtl = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
                </b-col>         
                <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><span class="pt-1 pr-2">Filter On</span></b-input-group-prepend>
                          <b-form-checkbox-group v-model="filterDtlOn" class="mt-1">
                            <b-form-checkbox value="vendor">Vendor Code</b-form-checkbox>
                            <b-form-checkbox value="vendor_name">Vendor Name</b-form-checkbox>
                            <b-form-checkbox value="invoice">Invoice No.</b-form-checkbox>
                            <b-form-checkbox value="po">PO Number</b-form-checkbox>
                          </b-form-checkbox-group>
                  </b-input-group>
                </b-col>         
            </b-row>
            <b-table
                class="mb-0"
                ref="tableLcy"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="aging.detail"
                :fields="tblDetail.fields"
                :current-page="tblDetail.page"
                :per-page="tblDetail.limit"
                :sort-by.sync="tblDetail.sortBy"
                :sort-desc.sync="tblDetail.sortDesc"
                :filter="filterDtlInput"
                :filterIncludedFields="filterDtlOn"
                @filtered="onFilterDetail"  @row-clicked="rowClicked"                
            >
                <template v-slot:cell(totalinv)="data">
                    {{ data.item.totalinv | numFormat }}
                </template>
                <template v-slot:cell(outstand)="data">
                      {{ data.item.outstand | numFormat }}
                </template>
                <template v-slot:cell(outstandLcy)="data">
                      {{ data.item.outstandLcy | numFormat }}
                </template>
                <template v-slot:cell(aging3Ori)="data">
                      {{ data.item.aging | numFormat }}
                </template>
                <template v-slot:cell(nilaibayar)="data">
                  <div v-if="(data.item.terpilih==1)" style="width:300px !important;">
                      <b-input-group>
                        <!-- <b-form-input v-model="modelDtlObj.nilaibayar" type="number" style="width:35% !important;" ></b-form-input> -->
                        <my-number v-model="modelDtlObj.nilaibayar" :precision="2" class="form-control text-right" separator="," style="width:35% !important;" ></my-number>
                        <b-form-select :options="['week1', 'week2', 'week3', 'week4']" :plain="true" v-model="modelDtlObj.weekplan"  size="sm" style="margin-left:2px;"/>                        
                        <b-button variant="success" size="sm" @click.stop="saveplanDtl()">
                          <i class="fa fa-check"></i>
                        </b-button>
                        <b-button variant="danger" size="sm" @click.stop="unselectDtl()">
                          <i class="fa fa-times"></i>
                        </b-button>
                      </b-input-group>
                  </div>
                  <div v-else>{{ data.item.nilaibayar | numFormat }} </div>
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col cols="4">
                    <div style="font-weight: bolder;">Total Outstanding : {{uanguser}} {{aging.totalLcy | numFormat}}</div>
                </b-col>
                <b-col cols="8">
                    <b-row >
                      <b-col cols="6" style="text-align:center">
                        <div>
                          Showing {{(tblDetail.page - 1) * tblDetail.limit + 1}}
                          to <span v-if="((tblDetail.page * tblDetail.limit)>tblDetail.total)">{{tblDetail.total}}</span> <span v-else>{{tblDetail.page * tblDetail.limit}}</span>
                          of {{tblDetail.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                          <select  v-model="tblDetail.limit"  style="width:60px;">
                            <option>10</option>
                            <option>20</option>
                            <option>30</option>                            
                            <option>40</option>
                            <option>50</option>                            
                            <option>60</option>                            
                            <option>70</option>                            
                            <option>80</option>                            
                            <option>90</option>                            
                            <option>100</option>                            
                          </select>
                        </div>
                        <b-form-checkbox v-model="filterDtlShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterDtlShow }}</b> Filter
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="6">            
                        <b-pagination 
                          align="right"
                          :total-rows="tblDetail.total"
                          :per-page="tblDetail.limit"
                          v-model="tblDetail.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
  .frm-appaymplan {
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
      }    
  }
 
</style>

<script>
import moment from 'moment';
import appaymplan from "../../apis/appaymplan";
import myNumber from "../../components/my-number";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        createdate: { required },
    },
  }, 
  data() {
    return {
      showFilter: true,
      isLoading:false,
      showSummary:true,
      showPrintConfirm:false,
      showReport:false,
      reportUrl: null,
      model: {tabIndex:0, kodeacc:'',tgl1:'',createdate:''},
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      aging : {rekap:[], detail:[], seting:{}},
      agingDtl: {list:[], outstand: 0, outstandLcy: 0},
      subtotal : {},
      tblDetail: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "nomor",
            label: "AP Number",
            sortable: true
          },
          {
            key: "vendor",
            label: "Vendor Code",
            sortable: true
          },
          {
            key: "vendor_name",
            label: "Vendor Name",
            sortable: true
          },
          {
            key: "po",
            label: "PO Number",
            sortable: true
          },
          {
            key: "invoice",
            label: "Invoice #",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "totalinv",
            label: "Total Invoice",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "outstand",
            label: "Outstanding",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "outstandLcy",
            label: "Outstand LCY",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging",
            label: "Age (days)",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nilaibayar",
            label: "Payment Plan",
            thClass: "text-right",
            tdClass: "text-right",
            variant: 'success',
            sortable: true
          }
        ]
      },
      tblLcy: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "vendor",
            label: "Vendor Code",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "vendor_name",
            label: "Vendor Name",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "totalLcy",
            label: "Total Outstanding (IDR)",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging1Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging2Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging3Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging4Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging5Lcy",
            label: " > 180 Days",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "latestPaym",
            label: "Latest Paym",
            thStyle: "width:95px",
            sortable: true
          },
          {
            key: "totalByr",
            label: "Payment Plan",
            thClass: "text-right",
            tdClass: "text-right",
            variant: 'success',
            sortable: true
          },

        ]
      },
      tblRekap: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "vendor",
            label: "Vendor Code",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "vendor_name",
            label: "Vendor Name",
            sortable: true
          },
          {
            key: "totalLcy",
            label: "Total Outstanding (LCY)",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging1Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging2Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging3Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging4Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging5Lcy",
            label: " > 180 Days",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },       
          {
            key: "latestPaym",
            label: "Latest Paym",
            thStyle: "width:95px",
            sortable: true
          },
          {
            key: "totalByr",
            label: "Payment Plan",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            variant: 'success',
            sortable: true
          },
        ]
      },
      filter: null,
      filterOn:[] , 
      filterShow:'Show',   
      filterVnd: null,
      filterVndOn:[] , 
      filterVndShow:'Show',   
      filterDtl: null,
      filterDtlInput: null,
      filterDtlOn:[] , 
      filterDtlShow:'Show',   
      modelDtl:'',
      modelDtlObj:{nilaibayar:0, weekplan:'week1'},
    };
  },
  components: {Loading, myNumber},
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    account() {
        return this.model.account;
    },
  },
  watch:{
    account: function(newval) {
      const obj=this.accounts.find(d => d.value === newval);
        this.model.namaacc=obj.text || '';
        this.model.kodeacc=obj.kodeacc;
        // console.log(`${this.model.account} | ${this.model.namaacc}`);
    },
    filterShow: function(newval) {
      setTimeout(() => {
           if (this.filterShow=='Show') this.filter=''
              this.filter=''
      }, 200);
    },
    filterVndShow: function(newval) {
      setTimeout(() => {
           if (this.filterVndShow=='Show') this.filterVnd=''
      }, 200);
    },
    filterDtlShow: function(newval) {
      setTimeout(() => {
           if (this.filterDtlShow=='Show') this.filterDtl=''
      }, 200);
    },
    filterDtl: function(newval) {
      // this.isBusy=true;
      setTimeout(() => {
           if ( this.filterDtlInput!=newval) this.filterDtlInput=newval;
      }, 800);
    },
    
  },   created: async function(){
      if (this.$route.params.payplankey)  {
        this.isLoading=true;      
        const result = await appaymplan.detail(this.$route.params);
        this.isLoading=false;      
        if (result.success) {
            this.model= result.planhdr;
            this.model.createdate = this.model.createdate ? moment(this.model.createdate).format('YYYY-MM-DD') : '';
            this.model.paym_sched = this.model.paym_sched ? moment(this.model.paym_sched).format('YYYY-MM-DD') : '';
            this.model.expir_sched = this.model.expir_sched ? moment(this.model.expir_sched).format('YYYY-MM-DD') : '';
            this.aging.rekap = result.data[0];
            this.aging.detail = result.data[1];
            this.aging.valas = result.data[2];
            this.aging.seting = result.data[3][0];
            this.aging.rekapVendor = result.data[4];
            this.aging.totalLcy = 0;
            this.aging.aging1Lcy = 0;
            this.aging.aging2Lcy = 0;
            this.aging.aging3Lcy = 0;
            this.aging.aging4Lcy = 0;
            this.aging.aging5Lcy = 0;
            this.aging.rekap.forEach((ap) => {
              this.aging.totalLcy += ap.totalLcy;
              this.aging.aging1Lcy += ap.aging1Lcy;
              this.aging.aging2Lcy += ap.aging2Lcy;
              this.aging.aging3Lcy += ap.aging3Lcy;
              this.aging.aging4Lcy += ap.aging4Lcy;
              this.aging.aging5Lcy += ap.aging5Lcy;
            });
          // this.$forceUpdate();
          this.tblDetail.total= this.aging.detail.length;
          this.totalDetail = this.aging.totalLcy ;
          this.tblLcy.total= this.aging.rekap.length;
          this.tblRekap.total= this.aging.rekapVendor.length;
          if (result.message) toastr.warn(result.message,'WARNING',10000);
        } else {
          if (result.message) toastr.error(result.message,'ERROR',10000);
        }

      } 
      // else {
      //   const createdate = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
      //   this.model.createdate=createdate.format('YYYY-MM-DD');
      // }
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },  
    onFilterVendor(filteredItems) {
      this.tblRekap.total = filteredItems.length;
      this.tblRekap.page = 1;
    },  
    onFilterDetail(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblDetail.total = filteredItems.length;
      this.tblDetail.page = 1;
      this.totalDetail = filteredItems.reduce((a, b) => a + b.outstandLcy, 0);
    },  
    processValas() {
      this.isLoading=true;
      toastr.info('Re-calculating AP foreign Currency');
      let apValas;
          this.aging.valas.forEach((uang, index) => {
              appaymplan.updatevalas(uang);
              apValas = this.aging.rekap.reduce((newArr, item, idx) => {
                  if (item.matauang === uang.matauang) {
                      newArr.push({
                          idx, totalOri: item.totalOri, aging1Ori: item.aging1Ori, aging2Ori: item.aging2Ori, aging3Ori: item.aging3Ori, aging4Ori: item.aging4Ori, aging5Ori: item.aging5Ori
                      });
                  }
                  return newArr;
              }, []);
              apValas.forEach((ap) => {
                  this.aging.rekap[ap.idx].totalLcy = ap.totalOri * uang.kurs;
                  this.aging.rekap[ap.idx].aging1Lcy = ap.aging1Ori * uang.kurs;
                  this.aging.rekap[ap.idx].aging2Lcy = ap.aging2Ori * uang.kurs;
                  this.aging.rekap[ap.idx].aging3Lcy = ap.aging3Ori * uang.kurs;
                  this.aging.rekap[ap.idx].aging4Lcy = ap.aging4Ori * uang.kurs;
                  this.aging.rekap[ap.idx].aging5Lcy = ap.aging5Ori * uang.kurs;
              });
              apValas = this.aging.detail.reduce((newArr, item, idx) => {
                  if (item.matauang === uang.matauang) {
                      newArr.push({ idx, outstand: item.outstand });
                  }
                  return newArr;
              }, []);
              apValas.forEach((ap) => {
                  this.aging.detail[ap.idx].outstandLcy = ap.outstand * uang.kurs;
              });
          });
          const rekapVendor = [];
          let grpKey = '';
          let idxhasil = 0;
          this.aging.rekap.forEach(ap => {
              if (grpKey !== ap.vendor) {
                  rekapVendor.push(ap);
                  grpKey = ap.vendor;
                  idxhasil += 1;
              } else {
                  rekapVendor[idxhasil-1].totalLcy += ap.totalLcy;
                  rekapVendor[idxhasil-1].aging1Lcy += ap.aging1Lcy;
                  rekapVendor[idxhasil-1].aging2Lcy += ap.aging2Lcy;
                  rekapVendor[idxhasil-1].aging3Lcy += ap.aging3Lcy;
                  rekapVendor[idxhasil-1].aging4Lcy += ap.aging4Lcy;
                  rekapVendor[idxhasil-1].aging5Lcy += ap.aging5Lcy;
              }
          });
          this.aging.totalLcy = 0;
          this.aging.aging1Lcy = 0;
          this.aging.aging2Lcy = 0;
          this.aging.aging3Lcy = 0;
          this.aging.aging4Lcy = 0;
          this.aging.aging5Lcy = 0;
          this.aging.rekapVendor=rekapVendor;
            this.aging.rekap.forEach((ap) => {
              this.aging.totalLcy += ap.totalLcy;
              this.aging.aging1Lcy += ap.aging1Lcy;
              this.aging.aging2Lcy += ap.aging2Lcy;
              this.aging.aging3Lcy += ap.aging3Lcy;
              this.aging.aging4Lcy += ap.aging4Lcy;
              this.aging.aging5Lcy += ap.aging5Lcy;
            });

          this.isLoading=false;
          this.$forceUpdate();
    },  
    getRekap: function (row, col) {
      this.filterVnd=row.vendor;
      this.filterVndShow='Hide';
      this.model.tabIndex=1;
    },

    getDetail: function (row, col) {
      toastr.warn(row.vendor_name.toUpperCase(),`Loading Detail Outstanding`);
      setTimeout(() => {
        this.filterDtlOn=['vendor'];      
        this.filterDtl=row.vendor;
        this.filterDtlInput=row.vendor;
        this.filterDtlShow='Hide';
        this.model.tabIndex=2;        
      }, 100);
      // this.$forceUpdate();
    },
    rowClicked(record, index) {
        if ((this.modelDtl) && (this.modelDtl.terpilih)) {
            delete this.modelDtl.terpilih;
        }
        this.modelDtl = record;
        record.terpilih= 1;
        this.modelDtlObj.payplankey= this.model.payplankey; 
        this.modelDtlObj.payplandtkey=record.payplandtkey || ''; 
        this.modelDtlObj.apinvkey=record.apinvkey;
        this.modelDtlObj.nilaibayar=record.nilaibayar || record.outstand; 
        this.modelDtlObj.vendor_id=record.vendor_id;
        this.modelDtlObj.aging=record.aging;
        this.modelDtlObj.matauang=record.matauang;
        this.$forceUpdate();

    },
    saveplanDtl:async function() {
        this.isLoading=true;
        try {
            const response = await appaymplan.saveplandtl(this.modelDtlObj);
            this.modelDtl.nilaibayar=this.modelDtlObj.nilaibayar; 
            this.modelDtl.payplandtkey=response.payplandtkey; 
            const setingan = this.aging.seting;
            const rekapVendor = this.aging.rekapVendor.find(r => r.vendor_id=this.modelDtlObj.vendor_id);
            if (rekapVendor){
                    rekapVendor.totalByr += (this.modelDtlObj.nilaibayar-this.modelDtl.nilaibayar);
                    if (this.modelDtlObj.aging <= setingan['apAge1']) {
                      rekapVendor.aging1Byr += (this.modelDtlObj.nilaibayar-this.modelDtl.nilaibayar);
                    } else if ((this.modelDtlObj.aging > setingan['apAge1']) && (this.modelDtlObj.aging <= setingan['apAge2'])) {
                        rekapVendor.aging2Byr += (this.modelDtlObj.nilaibayar-this.modelDtl.nilaibayar);
                    } else if ((this.modelDtlObj.aging > setingan['apAge2']) && (this.modelDtlObj.aging <= setingan['apAge3'])) {
                      rekapVendor.aging3Byr += (this.modelDtlObj.nilaibayar-this.modelDtl.nilaibayar);
                    } else if ((this.modelDtlObj.aging > setingan['apAge3']) && (this.modelDtlObj.aging <= setingan['apAge4'])) {
                      rekapVendor.aging4Byr += (this.modelDtlObj.nilaibayar-this.modelDtl.nilaibayar);
                    } else if (this.modelDtlObj.aging > setingan['apAge5']) {
                      rekapVendor.aging5Byr += (this.modelDtlObj.nilaibayar-this.modelDtl.nilaibayar);
                    }
            }
            const rekap = this.aging.rekap.find(r => ((r.vendor_id=this.modelDtlObj.vendor_id) && (r.matauang=this.modelDtlObj.matauang)));
            if (rekap){
                    rekap.totalByr += (this.modelDtlObj.nilaibayar-this.modelDtl.nilaibayar);
                    if (this.modelDtlObj.aging <= setingan['apAge1']) {
                      rekap.aging1Byr += (this.modelDtlObj.nilaibayar-this.modelDtl.nilaibayar);
                    } else if ((this.modelDtlObj.aging > setingan['apAge1']) && (this.modelDtlObj.aging <= setingan['apAge2'])) {
                        rekap.aging2Byr += (this.modelDtlObj.nilaibayar-this.modelDtl.nilaibayar);
                    } else if ((this.modelDtlObj.aging > setingan['apAge2']) && (this.modelDtlObj.aging <= setingan['apAge3'])) {
                      rekap.aging3Byr += (this.modelDtlObj.nilaibayar-this.modelDtl.nilaibayar);
                    } else if ((this.modelDtlObj.aging > setingan['apAge3']) && (this.modelDtlObj.aging <= setingan['apAge4'])) {
                      rekap.aging4Byr += (this.modelDtlObj.nilaibayar-this.modelDtl.nilaibayar);
                    } else if (this.modelDtlObj.aging > setingan['apAge5']) {
                      rekap.aging5Byr += (this.modelDtlObj.nilaibayar-this.modelDtl.nilaibayar);
                    }
            }
            this.unselectDtl();
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },  
    unselectDtl: function() {
        if ((this.modelDtl) && (this.modelDtl.terpilih)) {
            delete this.modelDtl.terpilih;
        }
      this.modelDtl=undefined;
      this.$forceUpdate();
    },

    exportxls: async function() {
      // if (this.invalidFilter) {
      //       toastr.error('Please fill the form correctly.');
      // } else {
        this.isLoading=true;
        try {
            // this.model.createdate = this.model.createdate ? moment(this.model.createdate).format('YYYY-MM-DD') : '';
            const response = await appaymplan.export(this.model);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR',10000);
            }
        }
      // }
    },  
    close(){
          // router.push("home");
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'treasury.appaymplanfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'treasury.appaymplan'});
      }

    }
  }
};
</script>
